export default __webpack_public_path__ + "static/media/deco3_transp.963478d8.png";